import { LanguageDirection } from '../../entities';
import { getCurrentLanguage } from '../../utils/getCurrentLanguage';
import { getLanguageDirection } from '../../utils/getLanguageDirection';

export class LocalizationService {
  private get language() {
    return getCurrentLanguage();
  }

  get isRtl() {
    return getLanguageDirection(this.language) === LanguageDirection.RTL;
  }
}
